import type { PropsWithChildren } from 'react';

import { OverflowCarousel } from '@ingka/carousel';

import './styles.scss';

/**
 * @returns The children cards wrapped and rendered using Skapa `<OverflowCarousel />` component
 */
export const Carousel = ({ children }: PropsWithChildren) => {
    return <OverflowCarousel className="carousel_container">{children}</OverflowCarousel>;
};
